import { styled } from '@/styled-system/jsx';

import { Tabs } from '@zillow/constellation-10';

export const TabPanel = styled(Tabs.Panel, {
  base: {
    overflow: 'scroll',
    maxHeight: { base: 'calc(100vh - 235px)', lg: '612px' },
  },
});
